import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

type ApolloClientState = {
  isApolloClientAuthenticated: boolean;
};

type ApolloClientActions = {
  setApolloClientAuthenticated: (isAuthenticated: boolean) => void;
};

const initialState: ApolloClientState = {
  isApolloClientAuthenticated: false,
};

export const createApolloClientSlice: WaterlyAppStateCreator<ApolloClientActions, ApolloClientState> = (
  set,
) => ({
  ...initialState,

  setApolloClientAuthenticated: (isAuthenticated: boolean) => {
    set({ isApolloClientAuthenticated: isAuthenticated }, undefined, "apolloClient:setIsAuthenticated");
  },
});
